import { render, staticRenderFns } from "./PublisherInfoList.vue?vue&type=template&id=0db9d8d1"
import script from "./PublisherInfoList.vue?vue&type=script&lang=js"
export * from "./PublisherInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports